import React, { useEffect, useState } from "react"
import Button from "aldoo-ra/Button"
import Typography from "aldoo-ra/Typography"
import { listChecks, deleteCheck, pauseCheck } from "../api"
import CheckEditor from "./CheckEditor"

const kindLabel = {
  ping: "Ping",
  http200: "HTTP 200",
  payload: "Payload",
  screenshot: "Screenshot",
}

const ResultBadge = ({ r }) => {
  if (!r || r.ok === null || r.ok === undefined) return <span className="text-text_secondary text-xs">never run</span>
  const color = r.ok ? "bg-success/10 text-success" : "bg-error/10 text-error"
  return (
    <span className={`text-xs px-2 py-0.5 rounded ${color}`}>
      {r.ok ? "OK" : "FAIL"}{r.latencyMs != null ? ` · ${r.latencyMs}ms` : ""}{r.statusCode ? ` · ${r.statusCode}` : ""}{r.diffPct != null ? ` · diff ${r.diffPct.toFixed(1)}%` : ""}
    </span>
  )
}

const CheckList = ({ componentId }) => {
  const [checks, setChecks] = useState([])
  const [loading, setLoading] = useState(false)
  const [editing, setEditing] = useState(null)

  const refresh = async () => {
    setLoading(true)
    const r = await listChecks({ componentId })
    setChecks(r?.checks || [])
    setLoading(false)
  }

  useEffect(() => { refresh() }, [componentId])

  const onDelete = async (c) => {
    if (!confirm(`Delete check "${c.name || c.url}"?`)) return
    await deleteCheck(c._id)
    refresh()
  }

  const togglePause = async (c) => {
    const paused = c.pausedUntil && new Date(c.pausedUntil) > new Date()
    if (paused) await pauseCheck(c._id, null, true)
    else await pauseCheck(c._id, new Date(Date.now() + 60 * 60 * 1000).toISOString())
    refresh()
  }

  if (editing !== null) {
    return (
      <CheckEditor
        componentId={componentId}
        check={editing}
        onClose={() => { setEditing(null); refresh() }}
      />
    )
  }

  return (
    <div className="space-y-3">
      <div className="flex items-center justify-between">
        <Typography variant="admin_h3">Checks</Typography>
        <Button onClick={() => setEditing({})}>Add check</Button>
      </div>
      {loading && <div>Loading...</div>}
      {!loading && checks.length === 0 && <div className="text-text_secondary">No checks yet. Add one with a URL and action.</div>}
      <div className="grid gap-2">
        {checks.map((c) => {
          const paused = c.pausedUntil && new Date(c.pausedUntil) > new Date()
          return (
            <div key={c._id} className="p-3 rounded-lg bg-paper border border-bordered">
              <div className="flex items-center justify-between gap-2">
                <div className="min-w-0 flex-1">
                  <div className="font-medium truncate">
                    {c.name || c.url} <span className="text-xs text-text_secondary">[{kindLabel[c.kind] || c.kind}]</span>
                  </div>
                  <div className="text-xs text-text_secondary truncate">{c.url} · every {c.schedule?.intervalSec}s{paused ? " · PAUSED" : ""}</div>
                  <div className="mt-1"><ResultBadge r={c.lastResult} /></div>
                </div>
                <div className="flex gap-2 shrink-0">
                  <Button variant="secondary" onClick={() => togglePause(c)}>{paused ? "Resume" : "Pause"}</Button>
                  <Button variant="secondary" onClick={() => setEditing(c)}>Edit</Button>
                  <Button variant="danger" onClick={() => onDelete(c)}>Delete</Button>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default CheckList
